import { render, staticRenderFns } from "./RrhhReport.vue?vue&type=template&id=f298a89a&"
import script from "./RrhhReport.vue?vue&type=script&lang=js&"
export * from "./RrhhReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports